export default __webpack_public_path__ + "static/media/e2iLogo.d4757e7a.svg";